import React, { useState } from 'react';
import i18next from 'i18next';

import ArtpDropdown from '../../../../common/DropDown';

export const capitalize = label => label && `${label.charAt(0).toUpperCase()}${label.slice(1).toLowerCase()}`;

const DatesDropdown = ({ choose, dates: { from, to } }) => {
  const [dtStart, setDtStart] = useState(from);
  const [dtEnd, setDtEnd] = useState(to);

  return (
    <ArtpDropdown
      right
      title={i18next.t('events.list.filters.dates.title')}
      render={({ close }) => (
        <div className="events-list-filter-bar-dates-dropdown">
          <div className="flex-container">
            <div className="form-group">
              <label htmlFor="events-filter-date-start">{i18next.t('events.list.filters.dates.from')}</label>
              <input
                className="form-control"
                type="date"
                name="events-filter-date-start"
                id="events-filter-date-start"
                defaultValue={dtStart}
                onChange={e => setDtStart(e.target.value)}
                onClick={e => e.stopPropagation()}
              />
            </div>
            <i className="fa fa-arrow-right font-1-5em" />
            <div className="form-group">
              <label htmlFor="events-filter-date-expire">{i18next.t('events.list.filters.dates.to')}</label>
              <input
                className="form-control"
                type="date"
                name="events-filter-date-expire"
                id="events-filter-date-expire"
                defaultValue={dtEnd}
                onChange={e => setDtEnd(e.target.value)}
                onClick={e => e.stopPropagation()}
              />
            </div>
          </div>
          <div className="validation-button">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                choose(dtStart, dtEnd);
                close();
              }}
            >
              {i18next.t('events.list.filters.dates.confirm')}
            </button>
          </div>
        </div>
      )}
    />
  );
};

export default DatesDropdown;
